import { CDN_URL, appId } from '@/config/index.js';
import { getSign } from '@/api/account';
import {actGetSign} from '@/api/activity';

// config接口注入权限验证配置
export const wxConfig = async () => {
 let r = await getSign({
    url: `${location.href.split('#')[0]}`,
  });
  // 活动获取签名临时接口
  // const activityPageList = ['seckill'];
  // const isAct = activityPageList.findIndex(item => window.location.href.includes(item));
  // if (isAct == -1) {
  //   r = await getSign({
  //     url: `${location.href.split('#')[0]}`,
  //   });
  // } else {
  //   r = await actGetSign({
  //     url: `${location.href.split('#')[0]}`,
  //   });
  //   if (Array.isArray(r.data) && !r.data.length) {
  //     r = await getSign({
  //       url: `${location.href.split('#')[0]}`,
  //     });
  //   }
  // }
  const { timestamp, signature, noncestr } = r.data;
  // 通过config接口注入权限验证配置
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: noncestr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名
    jsApiList: [
      'chooseImage', // 拍照或从手机相册中选图接口
      'previewImage', // 预览图片接口
      'uploadImage', // 上传图片接口
      'updateAppMessageShareData', // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
      'updateTimelineShareData', // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'closeWindow', // 关闭当前网页窗口接口
      'chooseWXPay'
    ], // 必填，需要使用的JS接口列表
  });
};

export const wxShareData = async shareData => {
  // 默认“分享朋友”信息
  const defaultMessageShareData = {
    title: '黑喵平台', // 分享标题
    desc: '分享让更多朋友加入', // 分享描述
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: `${window.location.protocol}${CDN_URL}/share/share_icon.jpg`, // 分享图标
    success: function() {
      console.log('分享朋友');
    },
  };

  // 默认“分享朋友圈”信息
  const defaultlineShareData = {
    title: '黑喵平台', // 分享标题
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: `${window.location.protocol}${CDN_URL}/share/share_icon.jpg`, // 分享图标
    success: function() {
      console.log('分享朋友圈');
    },
  };
  // 通过ready接口处理成功验证, 验证成功后需立即执行的操作放在此函数中
  wx.ready(function() {
    const messageShareData = shareData ? shareData[0] : defaultMessageShareData;
    const lineShareData = shareData ? shareData[1] : defaultlineShareData;
    wx.updateAppMessageShareData(messageShareData);
    wx.updateTimelineShareData(lineShareData);
    wx.onMenuShareTimeline(lineShareData);
    wx.onMenuShareAppMessage(messageShareData);
  });
};

export const wxPreviewImage = (current, urls) => {
  wx.previewImage({
    current, // 当前显示图片的http链接
    urls, // 需要预览的图片http链接列表
  });
};
